import { BooleanProperty } from '@baeso-ui/baeso-observable';
import { FormControl } from '../BaseVM';
export class DateInputVM extends FormControl {
    constructor(init) {
        super(init);
        this.editable = (init === null || init === void 0 ? void 0 : init.editable) ? init.editable : new BooleanProperty('editable', true);
        this.required = (init === null || init === void 0 ? void 0 : init.required) ? init.required : new BooleanProperty('required', false);
    }
}
